export const ButtonStyle = {
	// style object for base or default style
	baseStyle: {
		fontWeight: '400',
	},
	variants: {
		linkAsButton: {
			color: 'brand.600',
			border: 'none',
			padding: '0',
			display: 'inline-block',
			_focus: { boxShadow: 'none' },
			'&:hover': {
				textDecoration: 'underline',
			},
		},
		navbarButton: {
			borderRadius: 'full',
			border: '1px solid rgba(255, 255, 255,0.5)',
			color: '#FFFFFF',
		},
		sidebarButton: {
			bg: '#FFFFFF',
			border: '1px solid #009B76',
			color: 'brand.700',
			borderRadius: '18px',
			h: '28px',
			_active: {
				bgColor: '#FFE36D',
				color: '#000000',
				border: 'none',
			},
			fontSize: '13px',
			fontWeight: '500',
			padding: '8px 20px 8px 20px',
			fontStyle: 'normal',
		},
		requestButton: {
			bg: '#FFFFFF',
			border: '1px solid #009B76',
			color: 'brand.700',
			borderRadius: '18px',
			h: '1.75rem',
			_active: {
				bgColor: '#009B76',
				color: '#FFFFFF',
				border: 'none',
			},
			fontSize: '13px',
			fontWeight: '500',
			padding: '8px 20px 8px 20px',
			fontStyle: 'normal',
		},
		collapsedSidebarButton: {
			bg: '#FFFFFF',
			color: '#000000',
			h: '50px',
			w: '100%',
			borderBottom: '0.5px solid #F1F3F9',
			_active: {
				bgColor: '#FFDE55',
				color: '#000000',
				borderRight: '3px solid #009B76',
				borderRadius: '0px',
			},
			fontSize: '11px',
			fontWeight: '400',
			fontStyle: 'normal',
		},
		idcardButton: {
			bg: '#FFFFFF',
			border: '1px solid #009B76',
			color: 'brand.700',
			borderRadius: '18px',
			h: '32px',
			mt: '7px',
			fontSize: '13px',
			fontWeight: '500',
			padding: '8px 20px 8px 20px',
			fontStyle: 'normal',
		},
		menuTabButton: {
			fontSize: '16px',
			fontWeight: '500',
			background: 'transparent',
			color: '#009B76',
			height: '100%',
			_active: {
				fontWeight: '900',
				color: '#000000',
				paddingTop: '3px',
				borderBottom: '3px solid black',
				borderRadius: '0px',
			},
		},
		whatsNextButton: {
			fontSize: '0.875rem',
			fontWeight: '500',
			background: 'white',
			border: '1px solid #42529C',
			borderRadius: '17px',
			color: 'blue.600',
		},
		modalCloseButton: {
			borderRadius: '17px',
			h: '2.25rem',
			fontSize: '0.875rem',
			padding: '0.5rem 2.3rem',
			color: 'brand.700',
			border: '1px solid #009B76',
		},
		modalSubmitButton: {
			borderRadius: '17px',
			h: '2.25rem',
			lineHeight: '1',
			fontSize: '0.875rem',
			padding: '0.5rem 2.3rem',
			color: 'white',
			background: 'linear-gradient(266.6deg, #009B76 2.89%, #008363 93.97%)',
			boxShadow: '1px 1px 1px rgba(0, 0, 0, 0.1)',
		},

		// Icon Buttons
		requestSummaryIconButton: {
			color: 'brand.700',
			width: '1.875rem',
			minWidth: '1.875rem',
			height: '1.875rem',
			background: 'white',
			borderRadius: '50%',
			'&:focus': {
				bg: 'white',
			},
			'&:hover': {
				bg: 'white',
			},
		},
	},
	// default values for 'size', 'variant' and 'colorScheme'
	defaultProps: {},
}
